import React from 'react';
import css from './LandingPage.css';
import Slider from 'react-slick';

import storyIcon from '../../assets/landingpage/storyIcon.png';

import evenLim from '../../assets/landingpage/avatars/EvenLim.jpg';
import shareenTan from '../../assets/landingpage/avatars/ShareenTan.jpeg';
import shimeiHe from '../../assets/landingpage/avatars/ShimeiHe.jpg';
import jonathanLai from '../../assets/landingpage/avatars/JonathanLai.jpg';
import benChan from '../../assets/landingpage/avatars/BenChan.jpeg';

const datas = [
  {
    content:
      'Drive lah strives to be the Best - Second to None! It is innovative, dares to create new pathways, people-centric and always delivers on its service! Drive lah is committed on building trust within the community it serves.',
    name: 'Even Lim',
    avatar: evenLim,
  },
  {
    content:
      'Drive Lah has a great and very responsive customer service team. It is an easy and hassle-free platform for me to rent out my car for extra income rather than keeping my car idle when not in use. The instant booking feature is great! No confusion and is clear-cut.',
    name: 'Shareen Tan',
    avatar: shareenTan,
  },
  {
    content:
      'The Drive lah team makes the experience of car-sharing relatively stress-free. They are an awesome group of people to work with - quick to respond, always ready to help, positive and open to suggestions for improvements. Keep up the good work! 👍',
    name: 'Shimei He',
    avatar: shimeiHe,
  },
  {
    content: 'Convenient way to rent out your car with insurance covered. Hassle free!',
    name: 'Jonathan Lai',
    avatar: jonathanLai,
  },
  {
    content: 'Drive Lah is a safe, easy and convenient platform for car owners to lease their unused car 24-7 for extra income to offset their car maintenance in Singapore. Thanks Drive Lah!',
    name: 'Ben Chan',
    avatar: benChan,
  },
];

const Story = ({ content, name, avatar }) => {
  return (
    <div className={css.story}>
      <div className={css.storyContentWrapper}>
        <img src={storyIcon} height={100} />
        <div className={css.storyContent}>{content}</div>
      </div>
      <div className={css.avatarWrapper}>
        <img src={avatar} className={css.avatar} />
        <div className={css.storyName}>{name}</div>
      </div>
    </div>
  );
};

const SectionStories = () => {
  const sliderConfig = {
    infinite: false,
    slidesToScroll: 1,
    slidesToShow: 3,
    initialSlide: 0,
    infinite: false,
    dots: false,
    arrows: true,
    adaptiveHeight: false,
    responsive: [
      {
        breakpoint: 1920,
        settings: {
          slidesToShow: 3,
          initialSlide: 0,
          infinite: false,
          dots: false,
          arrows: true,
        },
      },
      {
        breakpoint: 1440,
        settings: {
          slidesToShow: 3,
          initialSlide: 0,
          infinite: false,
          dots: false,
          arrows: true,
        },
      },
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
          initialSlide: 0,
          infinite: false,
          dots: false,
          arrows: true,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1.25,
          slidesToScroll: 1,
          initialSlide: 0,
          dots: true,
          arrows: false,
        },
      },
    ],
  };
  return (
    <div className={css.sectionStories}>
      <div className={css.sectionStoriesTitleWrapper}>
        <div className={css.sectionTitle}>{'Stories from\nour hosts'}</div>
        <div className={css.sectionStoriesDescription}>They are sharing their car on Drive lah</div>
      </div>
      <div className={css.sliderWrapper}>
        <Slider {...sliderConfig}>
          {datas.map(s => (
            <div className={css.storyWrapper}>
              <Story {...s} />
            </div>
          ))}
        </Slider>
      </div>
    </div>
  );
};

export default SectionStories;
